import React from "react";
import { COLORS, Typo } from "../../../../../layout/theme";
import {
	BigChartContainer,
	Container,
	Dashboard1Container,
	FilterContainer,
	HeaderContainer,
} from "./styles";
import { Button, DatePicker, Select } from "antd";
import { numberWithDotAndCommas } from "../../../../../../utils/numberWithDotAndComas";
import Box from "../box/Box";
import { BiCheck, BiCoinStack, BiDollar, BiTrash } from "react-icons/bi";
import DebounceSelectSeller from "../../../../../common/debounce-select-seller/DebounceSelectSeller";
import { CONSTANTS } from "../../../../../../utils/constants";
import CustomAntdTooltip from "../../../../../common/custom-antd-tooltip/CustomAntdTooltip";

export default function InitiativeDashboard({
	dashboard,
	distributors,
	selectDistributor,
	handleDateChange,
	deleteFilters,
	isLoading,
	selectedDistributor,
	rangeDate,
	selectedChain,
	selectChain,
	chains,
	selectedCategory,
	selectCategory,
	categories,
	sellers,
	selectSeller,
	selectedSeller,
	userdata,
	initiatives,
	selectInitiative,
	selectedInitiative,
	productTotalvsInitiatives,
	timeInitiativesSalesGraph,
	timeInitiativesUnitsGraph,
	initiativeGraphSelector,
	selectInitiativeGraph,
	initiativesPeriod,
	selectInitiativesPeriod,
	handleApplyFilters,
}) {
	return (
		<Dashboard1Container>
			<FilterContainer>
				<Container
					style={{
						flexDirection: "row",
						alignItems: "end",
						justifyContent: "center",
						width: "160px",
					}}
				>
					<CustomAntdTooltip
						placement="top"
						width="110px"
						tooltipContent={[
							{
								title: `Aplicar filtros`,
							},
						]}
					>
						<Button
							type="primary"
							onClick={handleApplyFilters}
							icon={<BiCheck />}
							style={{
								borderRadius: 20,
								backgroundColor: COLORS.Success,
								borderColor: COLORS.Success,
							}}
						/>
					</CustomAntdTooltip>
					<CustomAntdTooltip
						placement="top"
						width="100px"
						tooltipContent={[
							{
								title: `Borrar filtros`,
							},
						]}
					>
						<Button
							type="danger"
							onClick={deleteFilters}
							icon={<BiTrash />}
							style={{ borderRadius: 20 }}
						/>
					</CustomAntdTooltip>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Fecha
					</Typo>
					{rangeDate ? (
						<DatePicker.RangePicker
							format="DD/MM/YYYY"
							value={rangeDate}
							onChange={(e) => handleDateChange(e)}
							disabled={initiativesPeriod === CONSTANTS.PERIOD_CURRENT}
						/>
					) : (
						<DatePicker.RangePicker
							format="DD/MM/YYYY"
							onChange={(e) => handleDateChange(e)}
							placeholder={["Desde", "Hasta"]}
							disabled={initiativesPeriod === CONSTANTS.PERIOD_CURRENT}
						/>
					)}
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Período
					</Typo>
					<Select
						showSearch
						//allowClear
						placeholder="Período"
						optionFilterProp="children"
						value={initiativesPeriod}
						onChange={(e) => selectInitiativesPeriod(e)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={CONSTANTS.MOBILE_DASHBOARD_PERIODS}
						style={{ width: 120 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Droguería
					</Typo>
					<Select
						showSearch
						placeholder="Droguería"
						optionFilterProp="children"
						value={selectedDistributor}
						onChange={(e, o) => selectDistributor(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={distributors}
						style={{ width: 140 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Cadena
					</Typo>
					<Select
						showSearch
						placeholder="Cadena"
						optionFilterProp="children"
						value={selectedChain}
						onChange={(e, o) => selectChain(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={chains}
						style={{ width: 120 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Categoria
					</Typo>
					<Select
						showSearch
						placeholder="Categoria"
						optionFilterProp="children"
						value={selectedCategory}
						onChange={(e, o) => selectCategory(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={categories}
						style={{ width: 160 }}
					/>
				</Container>
				<Container>
					<Typo type="primary" level={6}>
						Iniciativa
					</Typo>
					<Select
						showSearch
						placeholder="Iniciativa"
						optionFilterProp="children"
						value={selectedInitiative}
						onChange={(e, o) => selectInitiative(e, o)}
						filterOption={(input, option) =>
							(option?.label ?? "").toLowerCase().includes(input.toLowerCase())
						}
						options={initiatives}
						style={{ width: 150 }}
					/>
				</Container>
				{!(!userdata.p_shop && userdata.p_mobile) && (
					<Container>
						<Typo type="primary" level={6}>
							Vendedor
						</Typo>
						<DebounceSelectSeller
							fetchCallback={sellers}
							placeholder="Vendedor"
							onValuesChange={selectSeller}
							initialValues={selectedSeller}
						/>
					</Container>
				)}
			</FilterContainer>
			<HeaderContainer>
				<Box
					data={numberWithDotAndCommas((dashboard?.totalYearSales).toFixed(0))}
					dataPrefix={"$"}
					type="headerBoxInitiatives"
					title={
						<Typo texto="light" type="primary">
							Total ventas
						</Typo>
					}
				/>
				<Box
					data={numberWithDotAndCommas(
						(dashboard?.totalInitiativesSales).toFixed(0)
					)}
					dataPrefix={"$"}
					type="headerBoxInitiatives"
					title={
						<Typo texto="light" type="primary">
							Total iniciativa
						</Typo>
					}
				/>
				<Box
					data={numberWithDotAndCommas(
						(dashboard?.totalYearSales === 0
							? 0
							: (dashboard?.totalInitiativesSales / dashboard?.totalYearSales) *
							  100
						).toFixed(2)
					)}
					dataPrefix={"%"}
					type="headerBoxInitiatives"
					title={
						<Typo texto="light" type="primary">
							Porcentaje de participación
						</Typo>
					}
				/>
			</HeaderContainer>
			<BigChartContainer>
				<Box
					type="timeChart"
					options={productTotalvsInitiatives}
					isLoading={isLoading}
					title={
						<Typo texto="light" type="primary">
							Ventas vs iniciativas
						</Typo>
					}
				/>
			</BigChartContainer>
			<BigChartContainer>
				<Box
					type="timeChartMultipleProduct"
					options={timeInitiativesSalesGraph}
					iconOption={<BiDollar size={20} />}
					option2={timeInitiativesUnitsGraph}
					iconOption2={<BiCoinStack size={20} />}
					selectProductGraph={selectInitiativeGraph}
					productGraph={initiativeGraphSelector}
					isLoading={isLoading}
					title={
						<Typo texto="light" type="primary">
							{initiativeGraphSelector === "SALES"
								? "Histórico ventas"
								: initiativeGraphSelector === "UNITS"
								? "Histórico unidades"
								: ""}
						</Typo>
					}
				/>
			</BigChartContainer>
		</Dashboard1Container>
	);
}
